import { Logo } from '@/components/icons/bitlyft-logo'

type AuthLayoutProps = {
	children: React.ReactNode
}
export const AuthLayout = ({ children }: AuthLayoutProps) => {
	return (
		<div className="flex h-full w-full flex-col items-center justify-center overflow-hidden">
			{/* Card container */}
			<div className="bg-card flex h-full w-full flex-col items-center justify-stretch rounded-md p-8 shadow-md sm:h-fit sm:max-w-125">
				<Logo className="h-11 w-11" />

				{children}
			</div>
		</div>
	)
}
